import {
  PieChartBaseComponent
} from '../pie-chart-base/pie-chart-base.component';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core';
import { ScaleTypes, D3Event } from '../charts.model';

@Component({
  selector: 'app-pie-chart-wrapper',
  templateUrl: './pie-chart-wrapper.component.html',
  styleUrls: ['./pie-chart-wrapper.component.scss']
})
export class PieChartWrapperComponent implements OnInit {
  @Input() data: any[];
  @Input() innerRadiusPrecentage = 55; // precentage
  @Input() valueName = 'value';
  @Input() labelName = 'label';
  @Input() chartTitle: string;
  @Input() infoTitle: string;
  @Input() invertedColor: boolean;
  @Input() interpolation: (t: number) => string;
  @Input() colorScale = ScaleTypes.SEQUENTIAL;

  @Output() elementClick = new EventEmitter<D3Event>();

  @ViewChild(PieChartBaseComponent) pieChart: PieChartBaseComponent;

  infoValue: string;
  infoLabel: string;
  showInfo: boolean;
  activePath: number = 0;

  constructor() {}

  ngOnInit() {}

  onMouseOver(event: D3Event) {
    const { d, i, elements } = event;
    this.activePath = i;
    this.showInfo = true;
    this.infoValue = this.prepareMainDescription(d.data.value);
    this.infoLabel = d.data.label;
  }

  onMouseOut(event: D3Event) {
    this.showInfo = false;
  }

  onElementClick(event: D3Event) {
    this.elementClick.emit(event);
  }

  private prepareMainDescription(selectedValue: number): string {
    const sum = this.data.reduce((acc, curr) => curr[this.valueName] + acc, 0);
    const percentage = (selectedValue * 100) / sum;
    return `${selectedValue} (${percentage.toFixed(0)}%)`;
  }
}
